<template>
  <section class="position-relative">
    <form
      :class="['report-form', 'py-lg-3', isCompact ? 'px-lg-3' : 'px-lg-5',
              { 'border-lg-dark': !isCompact }]"
      ref="form"
      @submit.prevent="submitForm"
      >
      <b-row>
        <b-form-group v-if="!isCompact"
        class="col-12 col-lg-6" label="Tipos de relatório:" label-for="reportType">
          <ButtonGroup
            v-model="options.reportType"
            @change="clearForm(); track(getReportTypeDescription($event), 'Selecionou tipo');"
            :buttons="reportTypeButtons"
            :isInvalid="!!errors.reportType"/>
          <b-form-invalid-feedback
            v-if="errors.reportType"
            class="d-block"
            v-html="errors.reportType"/>
        </b-form-group>
        <b-form-group :class="[isCompact ?'col-12 col-lg-12' : 'col-12 col-lg-6']"
          label="Anunciantes" label-for="anunciantes">
          <SearchBox
            :class="!advertisers.length ? 'loading-placeholder' : ''"
            :dataObject="advertisers"
            :searchCritery="'desCommissionEventSourceGroup'"
            :idToSelectOptions="'idtCommissionEventSourceGroup'"
            displayValue="desCommissionEventSourceGroup"
            :isInvalid="!!errors.products"
            :searchNameAll="'Todos os Anunciantes'"
            :placeholder="!advertisers.length ? 'Carregando anunciantes' : undefined"
            v-model="options.products"
            :radio="options.reportType !== consts.CONSOLIDATED || isCompact"
            @change="track(selectedAdvertiserName, 'Selecionou anunciante')"
            />
          <b-form-invalid-feedback
            v-if="errors.products"
            class="d-block"
            v-html="errors.products"
            />
        </b-form-group>
      </b-row>

      <b-form-group
        v-if="!isCompact"
        label="Filtros Salvos"
        label-for="savedFilters">
        <div v-if="savedFilters.length">
          <FilterSelector :options="savedFilters" v-model="selectedFilter"/>
        </div>
        <p v-else-if="savedFiltersError" class="py-2">
          {{ savedFiltersError }}
        </p>
        <div v-else class="loading-placeholder p-2">
          Carregando filtros salvos
        </div>
      </b-form-group>

      <b-row>
        <b-form-group
          class="col-12 col-lg-6"
          v-if="options.reportType === consts.DETAILED && !isCompact"
          label="Sites (opcional)"
          label-for="sites"
          >
          <SearchBox
            :dataObject="affiliatedDataUrls"
            :searchCritery="'desUrl'"
            :idToSelectOptions = "'idtUserSupplierUrl'"
            displayValue = "desUrl"
            :searchNameAll="'Todos os Sites'"
            v-model="options.sites"
            />
        </b-form-group>

        <b-form-group
          class="col-12 col-lg-6"
          v-if="options.reportType === consts.DETAILED && !isCompact"
          label="Identificadores (opcional)"
          label-for="Identificadores"
          >
          <SearchBox
            :dataObject="affiliatedDataLabels"
            :searchCritery="'desLabel'"
            :idToSelectOptions = "'idtUserSupplierLabel'"
            displayValue = "desLabel"
            :searchNameAll="'Todos os Identificadores'"
            v-model="options.identifiers"
            />
        </b-form-group>
      </b-row>

      <b-row class="align-items-center">
        <b-col cols="12">
          <label for="period">
            Período
          </label>
          <b-row align-content="between">
            <b-form-group class="col-12 col-lg order-lg-3 mb-lg-0">
              <ButtonSwipe
                groupClass="d-lg-flex justify-content-between"
                :options="periods"
                v-model="options.period"
                @change="options.startDate = '';
                        options.endDate = '';
                        showCustomPeriod = false;
                        track(getPeriodDescription($event), 'Selecionou período personalizado');"
                />
            </b-form-group>

            <span :class="[isCompact ? 'd-none d-lg-none' : 'd-none d-lg-inline order-lg-2 pt-2']">
              ou
            </span>

            <b-form-group
            :class="
            [isCompact ? 'col-12 col-lg-12 order-lg-1 mb-lg-10'
            : 'col-12 col-lg-4 order-lg-1 mb-lg-0'
            ]">
              <div
                class="d-lg-none"
                v-show="!showCustomPeriod"
                >
                <p class="text-center mb-0 report-form__show-custom-period
                          d-flex justify-content-center">
                  <span
                    class="pointer d-inline-flex justify-content-center
                          align-content-center text-neutral"
                    @click="showCustomPeriod = true; options.period = '';"
                    >
                    <img
                      class="report-form__show-custom-period__icon mr-2"
                      src="@/assets/images/icon-calendar.svg"
                      alt="#"
                      >
                      Período personalizado
                  </span>
                </p>
              </div>
              <b-row class="d-lg-block" v-show="showCustomPeriod">
                <b-col cols="12">
                  <b-form-row>
                    <b-col>
                      <date-picker
                        v-model="options.startDate"
                        @change="options.period = '';
                          track(options.startDate || 'Nenhum', 'Selecionou período inicial');"
                        placeholder="Início"
                        :min-date="minDate"
                        :max-date="options.endDate || maxDate"
                        :isInvalid="!!errors.period"
                        />
                    </b-col>
                    <b-col>
                      <date-picker
                        v-model="options.endDate"
                        @change="options.period = '';
                          track(options.endDate || 'Nenhum', 'Selecionou período final');"
                        placeholder="Término"
                        anchor="right"
                        :min-date="options.startDate || minDate"
                        :max-date="maxDate"
                        :isInvalid="!!errors.period"
                        />
                    </b-col>
                  </b-form-row>
                </b-col>
              </b-row>
              <b-form-invalid-feedback
                v-if="errors.period"
                class="d-block"
                v-html="errors.period"/>
            </b-form-group>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="mt-lg-3" align-v="center" align-h="end">
        <b-col cols="12" lg="">
          <b-form-group class="mb-lg-0">
            <ButtonSaveFilter
              v-if="!isCompact"
              v-model="savedFilters"
              :savedFilter="savedFilters"
              :options="options"
              :selectedFilter="selectedFilter"
              :validation="validateForm"
              @saveFilter="track('Salvar_filtro')"
              @updateFilter="track('Alterar_filtro')"
               />
          </b-form-group>
        </b-col>
        <b-col :class="[isCompact ? 'col-lg-12': 'col-lg-3']" cols="12">
          <b-button
            class="w-100"
            type="submit"
            variant="orange"
            :disabled="sending"
            >
            {{ options.reportType === consts.TRANSACTION ? 'Baixar relatório' : 'Gerar relatório' }}
          </b-button>
        </b-col>
      </b-row>
    </form>

    <div class="mt-lg-3"></div>

    <div v-if="sending"
      class="p-3 d-flex flex-column justify-content-center align-items-center
             text-center text-neutral"
      :class="isCompact ? [
        'position-absolute',
        'w-100',
        'h-100',
        'top-0',
        'left-0',
        'bg-default',
        'z-2',
        ] : ['border-lg-dark']">
      <span class="flex-grow-0 d-flex">
        <img src="@/assets/images/loader.svg" alt="Carregando...">
      </span>
      <span class="flex-grow-0 d-flex align-content-center">
        <span>Gerando relatório</span>
      </span>
    </div>

    <div v-if="downloadLink" class="p-3 border-lg-dark text-lg-center text-neutral">
      Seu relatório está pronto, clique
      <a :href="downloadLink" download="relatorios.xlsx">aqui</a> para baixar
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getStringFromDate } from '@/utils/dateUtils';
import { blobToBase64 } from '@/utils/fileUtils';
import ReportsApi from '@/services/reports';
import SearchBox from './SearchBox.vue';
import ButtonSwipe from './ButtonSwipe';
import FilterSelector from './FilterSelector';
import DatePicker from './form/DatePicker';
import ButtonGroup from './form/ButtonGroup';
import ButtonSaveFilter from './ButtonSaveFilter';

const CONSOLIDATED = 'CONSOLIDATED';
const DETAILED = 'DETAILED';
const TRANSACTION = 'TRANSACTION';
const AMIGOS_INDICADOS = 11;

const clearFormOptions = () => ({
  products: [],
  startDate: '',
  endDate: '',
  period: '',
  sites: [],
  identifiers: '',
});
const clearFormErrors = () => ({
  products: '',
  reportType: '',
  period: '',
});

export default {
  name: 'ReportForm',
  components: {
    SearchBox,
    ButtonSwipe,
    DatePicker,
    ButtonGroup,
    FilterSelector,
    ButtonSaveFilter,
  },
  data() {
    return {
      consts: {
        CONSOLIDATED,
        DETAILED,
        TRANSACTION,
      },
      options: {
        ...clearFormOptions(),
        reportType: CONSOLIDATED,
      },
      sending: false,
      periods: [{
        description: 'Hoje',
        value: 'TODAY',
      }, {
        description: 'Ontem',
        value: 'YESTERDAY',
      }, {
        description: 'Últimos 7 dias',
        value: 'LAST_WEEK',
      }, {
        description: 'Mês atual',
        value: 'THIS_MONTH',
      }, {
        description: 'Mês anterior',
        value: 'LAST_MONTH',
      }],
      SavedReportsSites: [],
      SavedReportLabels: [],
      SavedReportsProducts: [],
      minDate: null,
      maxDate: null,
      showCustomPeriod: false,
      selectedFilterId: '',
      errors: { ...clearFormErrors() },
      reportTypeButtons: [{
        name: 'Consolidado',
        value: CONSOLIDATED,
        class: 'button-consolidated',
      }, {
        name: 'Detalhado',
        value: DETAILED,
        class: 'button-detailed',
      }, {
        name: 'Transação',
        value: TRANSACTION,
        class: 'button-transactions',
      }],
      downloadLink: null,
    };
  },
  props: {
    isCompact: Boolean,
    initialOptions: Object,
  },
  computed: {
    ...mapGetters(['affiliateCampaigns', 'approvedUrls', 'affiliateLabels', 'savedFilters', 'savedFiltersError', 'selectedFilter']),
    advertisers() {
      if (this.options.reportType === DETAILED) {
        return this.affiliateCampaigns
          .filter(adv => adv.idtCommissionEventSourceGroup !== AMIGOS_INDICADOS);
      }
      return this.affiliateCampaigns;
    },
    affiliatedDataUrls() {
      return this.approvedUrls;
    },
    affiliatedDataLabels() {
      return this.affiliateLabels;
    },
    selectedAdvertiserName() {
      let joinedAdvertises = '';
      if (this.advertisers.length === this.options.products.length) {
        joinedAdvertises = 'Todos; ';
      }
      joinedAdvertises += this.advertisers
        .filter(adv => this.options.products.includes(adv.idtCommissionEventSourceGroup))
        .map(adv => adv.desCommissionEventSourceGroup)
        .join('; ');
      return joinedAdvertises || 'Nenhum';
    },
  },
  methods: {
    ...mapActions(['fetchFilters', 'deselectFilter']),
    updateSavedReportProducts(selectedReport) {
      this.SavedReportsProducts = selectedReport
        .commEventSourceGroupList.map(product => product.idtCommissionEventSourceGroup);
      this.options.products = this.SavedReportsProducts;
    },
    updateSelectedReportSites(selectedReport) {
      this.SavedReportsSites = selectedReport
        .userSupplierUrlList.map(url => url.idtUserSupplierUrl);
      this.options.sites = this.SavedReportsSites;
    },
    updateSelectedReportLabels(selectedReport) {
      this.SavedReportLabels = selectedReport
        .userSupplierLabelList.map(label => label.idtUserSupplierLabel);
      this.options.identifiers = this.SavedReportLabels;
    },
    updateSelectedReportsType(selectedReport) {
      this.options.reportType = selectedReport.indType;
    },
    updatePeriod(selectedReport) {
      if (selectedReport.indPeriod !== 'PERSONALIZED') {
        this.showCustomPeriod = false;
        this.options.period = selectedReport.indPeriod;
      } else {
        const startDate = new Date(selectedReport.datInitialPeriod);
        const endDate = new Date(selectedReport.datFinalPeriod);
        this.showCustomPeriod = true;
        this.options.startDate = getStringFromDate(startDate);
        this.options.endDate = getStringFromDate(endDate);
      }
    },
    validateForm() {
      let valid = true;

      if (this.options.products.length === 0) {
        this.errors.products = 'Selecione o <strong>anunciante</strong>';
        valid = false;
      }

      if (!this.options.period && (!this.options.startDate || !this.options.endDate)) {
        this.errors.period = 'Selecione o <strong>período</strong>';
        valid = false;
      }

      return valid;
    },
    async submitForm() {
      try {
        this.$emit('reset');
        if (this.validateForm()) {
          this.track(this.reportTypeButtons.filter(rtb => rtb.value === this.options.reportType)[0].name, this.options.reportType === this.consts.TRANSACTION ? 'Baixou relatório' : 'Gerou relatório');
          this.downloadLink = '';
          this.sending = true;
          const options = JSON.parse(JSON.stringify(this.options));
          if (options.reportType === TRANSACTION) {
            const blob = await ReportsApi.downloadReport(options);
            await this.createDownloadLink(blob);
          } else {
            const report = await ReportsApi.getReport(options);
            this.$emit('success', report);
          }
        } else {
          await this.$nextTick();
          this.$refs.form
            .querySelector('[isinvalid]')
            .querySelector('button,input')
            .focus();
        }
      } catch (error) {
        const errorMessage = error.code ? error.message : 'Ops! Não foi possível gerar o relatório.';
        this.$emit('error', new Error(errorMessage));
      } finally {
        this.sending = false;
      }
    },
    async createDownloadLink(blob) {
      const base64header = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
      const base64data = await blobToBase64(blob);
      this.downloadLink = base64data.replace(/(.+base64,)/, base64header);
    },
    clearForm() {
      Object.assign(this.options, clearFormOptions());
      Object.assign(this.errors, clearFormErrors());
      this.selectedFilterId = '';
    },
    getReportTypeDescription(value) {
      return this.reportTypeButtons.find(type => type.value === value).name;
    },
    getPeriodDescription(value) {
      return value ? this.periods.find(period => period.value === value).description : 'Nenhum';
    },
    getFilterSelected(value) {
      return JSON.stringify(this.savedFilters.filter(sf => sf.value === value)[0]) || 'Nenhum';
    },
    async animateScroll() {
      if (this.$refs && this.$refs.form) {
        await this.$refs.form.querySelectorAll('.button-swipe').forEach((buttonSwipeElement) => {
          const buttonSwipeWidth = buttonSwipeElement.getBoundingClientRect().width;
          const wrapperWidth = buttonSwipeElement.parentNode.getBoundingClientRect().width;
          if (buttonSwipeWidth > wrapperWidth) buttonSwipeElement.classList.add('shake-left');
        });
      }
    },

  },
  async created() {
    const yearAgo = new Date();
    // setando o minDate para até menos 5 anos atrás a partir da data atual
    yearAgo.setFullYear(yearAgo.getFullYear() - 5);
    this.minDate = getStringFromDate(yearAgo);

    const today = new Date();
    today.setDate(today.getDate() + 1);
    this.maxDate = getStringFromDate(today);

    if (this.initialOptions) Object.assign(this.options, this.initialOptions);

    await this.fetchFilters();
    this.animateScroll();
  },
  watch: {
    selectedFilter: {
      immediate: true,
      handler() {
        if (this.selectedFilter) {
          this.updateSelectedReportSites(this.selectedFilter);
          this.updateSelectedReportLabels(this.selectedFilter);
          this.updateSavedReportProducts(this.selectedFilter);
          this.updateSelectedReportsType(this.selectedFilter);
          this.updatePeriod(this.selectedFilter);
        } else {
          Object.assign(this.options, clearFormOptions());
        }
      },
    },
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit('change', this.options);
        this.$emit('reset');
      },
    },
    'options.period': {
      handler() {
        this.errors.period = '';
      },
    },
    'options.startDate': {
      handler() {
        this.errors.period = '';
      },
    },
    'options.endDate': {
      handler() {
        this.errors.period = '';
      },
    },
    'options.products': {
      handler() {
        this.errors.products = '';
      },
    },
    'options.reportType': {
      handler() {
        this.errors.reportType = '';
      },
    },
  },
  mounted() {
    if (this.isCompact) this.options.reportType = CONSOLIDATED;
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .button-group
  .button-group-item {
    @include text-size-regular();
  }

  .button-consolidated:before,
  .button-detailed:before,
  .button-transactions:before {
    content: '';
    width: 15px;
    height: 15px;
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    vertical-align: middle;
  }
  .button-consolidated:before {
    background-image: url('~@/assets/consolidated.svg');
  }
  .button-consolidated.active:before {
    background-image: url('~@/assets/consolidated_selected.svg');
  }
  .button-detailed:before {
    background-image: url('~@/assets/detailed.svg');
  }
  .button-detailed.active:before {
    background-image: url('~@/assets/detailed_selected.svg');
  }
  .button-transactions:before {
    background-image: url('~@/assets/transaction.svg');
  }
  .button-transactions.active:before {
    background-image: url('~@/assets/transaction_selected.svg');
  }
}
@media screen and (min-width: 992px){
  /deep/ {
    .button-save-filter {
      justify-content: flex-end !important;
    }
  }
}

@media screen and (min-width: 600px) {
  /deep/  {
    .button-swipe {
      display: block;
      margin: 4px;
    }

    .btn-outline-primary {
      margin-top: 4px;
    }
  }
}

@media screen and (max-width: 600px) {
  /deep/ {
    .btn-outline-primary:hover {
      color: #007bff;
      background-color: #ffffff;
      border-color: #007bff;
    }
    .button-swipe-wrapper, .button-group-wrapper {
      margin: 0 -15px;
      padding: 0 15px;
    }
  }
}
</style>
